import React from 'react'
import Switch from '@liveramp/motif/core/Switch'
import FormControl from '@liveramp/motif/core/FormControl'
import FormControlLabel from '@liveramp/motif/core/FormControlLabel'
import FormGroup from '@liveramp/motif/core/FormGroup'

export default function LabelPlacementDemo() {
  return (
    <FormControl component="fieldset">
      <FormGroup aria-label="position" name="position" row>
        <FormControlLabel
          value="start"
          control={<Switch />}
          label="Start"
          labelPlacement="start"
        />
        <FormControlLabel
          value="top"
          control={<Switch />}
          label="Top"
          labelPlacement="top"
        />
        <FormControlLabel
          value="bottom"
          control={<Switch />}
          label="Bottom"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="end"
          control={<Switch />}
          label="End"
          labelPlacement="end"
        />
      </FormGroup>
    </FormControl>
  )
}
